<template>
<div class="panel">
    <createWeekModal v-if="showCreateWeekModal"
                    :league_id="current.league.id"
                    @closeMessage="showCreateWeekModal = false"
                    @createdWeek="weekCreated"></createWeekModal>
    <messageModal v-if="showMessage" message="La nouvelle journée a été crée !" @closeMessage="showMessage = false"></messageModal>
    <div class="row columns">
        <div class="panel-title big-title">
            Rapport de match
        </div>
        <wizard :step="1"></wizard>
        <hr>
        <div class="panel-content" v-if="current && detailedHome && detailedVisitor">

          <div class="row columns section">
            <div class="title">#0 Infos Générales</div>
            <div class="row columns section">
              <div class="infos_gen">
                  <div class="field">
                                <div class="text-centered">Journée</div>
                                <div class="day-select large-10 columns ">
                                    <select v-model="match_week" @change="checkAlreadyPlayedMatch">
                                        <option disabled value="null">Choisissez</option>
                                        <option v-for="week of weekListForLeague"
                                            v-bind:value="week.id">{{week.title}}</option>
                                    </select>
                                </div>
                                <div class="large-2 columns day-select">
                                    <button  @click="showCreateWeekModal = true" class="small day-button">
                                        <i class="fa fa-plus" aria-hidden="true"></i>
                                    </button>
                                </div>
                  </div>
                  <div class="field">
                    <div class="text-centered">Date</div>
                    <datepicker v-model="match_date" language="fr"></datepicker>
                  </div>
                  <div class="field">
                    <div class="text-centered">Météo de départ</div>
                    <select v-model="weather">
                      <option value="0">Canicule</option>
                      <option value="1">Trés ensoleillé</option>
                      <option value="2">Clément</option>
                      <option value="3">Averse</option>
                      <option value="4">Blizzard</option>
                    </select>
                  </div>
                  <div class="field">
                    <div class="text-centered">Arbitre</div>
                    <select v-model="selectedReferee">
                      <option disabled value="null">Choisissez</option>
                      <option v-for="ref of $store.getters.refereeList"
                              v-bind:value="ref">{{ref.name}}</option>
                    </select>
                  </div>
                </div>
              <div class="">
                  <div v-if="match_week" class="large-9 large-centered columns ">
                    <div class="error" v-if="weekErrorsList.length > 0" v-for="err in errorsList" >{{err}}</div>
                  </div>
              </div>
            </div>
          </div>
          <div class="row columns section">
            <div class="title">#1 choix du stade</div>
            <div class="large-3 columns">
              <div class="mt-2">
                <input type="checkbox" id="basic_stadium" name="subscribe" v-model="normal_stadium">
                <label for="basic_stadium" class="cb_label">Stade Normal</label>
              </div>
              <div>
                <input type="checkbox" id="custom_stadium" name="subscribe" value="newsletter" v-model="special_stadium">
                <label for="custom_stadium" class="cb_label">Stade Spécial</label>
              </div>
            </div>
              <div class="large-4 columns ">
                <div class="text-left pb-1">Type</div>
                <select v-model="stadium_type" :disabled="normal_stadium">
                  <option disabled value="null">Choisissez</option>
                  <option v-for="stadium of $store.getters.stadiumTypeList"
                          v-bind:value="stadium">{{getStadiumTypeName(stadium)}}</option>
                </select>
              </div>
              <div class="large-5 columns ">
                <div class="text-left pb-1">Stade</div>
                <select v-model="selectedStadium" :disabled="normal_stadium || stadium_type === null">
                  <option disabled value="null">Choisissez</option>
                  <option v-for="stadium of $store.getters.stadiumList.filter(stad => {return stad.type === stadium_type})"
                          v-bind:value="stadium">{{stadium.name}}</option>
                </select>
            </div>
          </div>
          <div class="row columns section">
            <div class="title">#2 Fans Dévoués</div>
            <div class="row columns section">
              <div class="fans">
                <div></div>
                <div>fans dévoués</div>
                <div>valeure du D3</div>
                <div>Facteur de pop</div>
              </div>
              <div class="fans">
                <div class="match-team-name text-right">{{home.name}}</div>
                <div class="field">
                  <div class="inactive_field">
                    {{detailedHome.pop}}
                  </div>
                </div>
                <div class="field">
                  <input type="number" min="0" max="3" step="1" placeholder="jet du D3" v-model="home_pop_d3">
                </div>
                <div class="field">
                  <div class="inactive_field">{{home_pop_factor}}</div>
                </div>
              </div>
              <div class="fans">
                <div class="match-team-name text-right">{{visitors.name}}</div>
                <div class="field">
                  <div class="inactive_field">{{detailedVisitor.pop}}</div>
                </div>
                <div class="field">
                  <input type="number" min="0" max="3" step="1" placeholder="jet du D3" v-model="visitor_pop_d3">
                </div>
                <div class="field">
                  <div class="inactive_field">{{visitor_pop_factor}}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row columns section">
            <div class="title">#3 Coups de pouce</div>
            <div class="large-12 columns">
              <div class="inducements">
                <div></div>
                <div>VE initiale</div>
                <div>Petite monnaie</div>
                <div>Trésorerie</div>
                <div>VE finale</div>
                <div>Inducements</div>
              </div>
              <div class="inducements">
                <div class="match-team-name text-right">{{home.name}}</div>
                <div class="field">
                  <div class="inactive_field">{{detailedHome.TV}}</div>
                </div>
                <div class="field">
                  <div class="inactive_field">{{home_petty_cash}}</div>
                </div>
                <div class="field">
                  <input type="number"  v-model="home_treasury_for_inducement" min="0" step="10000">
                </div>
                <div class="field">
                  <div class="inactive_field">{{home_final_ve}}</div>
                </div>
                <div class="field">
                  <input type="text" placeholder="texte libre"  v-model="home_inducement">
                </div>
              </div>
              <div class="inducements">
                <div class="match-team-name text-right">{{visitors.name}}</div>
                <div class="field">
                  <div class="inactive_field">{{detailedVisitor.TV}}</div>
                </div>
                <div class="field">
                  <div class="inactive_field">{{visitor_petty_cash}}</div>
                </div>
                <div class="field">
                  <input type="number"  v-model="visitors_treasury_for_inducement" min="0" step="10000">
                </div>
                <div class="field">
                  <div class="inactive_field">{{visitor_final_ve}}</div>
                </div>
                <div class="field">
                  <input type="text" placeholder="texte libre" v-model="visitors_inducement">
                </div>
              </div>
            </div>
          </div>
          <div class="row columns">
            <div v-if="error_msg" class="large-8 columns large-centered error-lbl">
              {{error_msg}}
              <br>
            </div>
            <div class="large-8 columns large-centered error-lbl pb-4" v-if="errorsList.length > 0" v-for="err in errorsList" >
              {{err}}
              <br>
            </div>
          </div>
          <div class="row columns">
            <div class="large-2 columns large-centered">
              <button  @click="validate" class="full-width">Suivant</button>
            </div>
          </div>
        </div>
        <div v-else>
          <spinner></spinner>
        </div>
    </div>
</div>
</template>

<script>
import spinner from '../../common/spinner.vue'
import wizard from '../../common/wizard.vue'
import { mapGetters } from 'vuex'
import store from '../../../store/index.js'
import matchReport from '../../../api/match-report.api'
import teamReport from '../../../api/team-report.api'
import Datepicker from 'vuejs-datepicker'
import createWeekModal from '../../common/create-week-modal.vue'
import messageModal from '../../common/message-modal.vue'
import Multiselect from 'vue-multiselect'

export default {
  name: 'mrStep2',
  components: {
    spinner,
    wizard,
    Datepicker,
    createWeekModal,
    messageModal,
    Multiselect
  },
  props: {
    'id': Number
  },
  data () {
    return {
      'weather': null,
      'match_date': null,
      'match_week': null,
      'home_fans': null,
      'home_fame': null,
      'home_inducement': null,
      'home_treasury_for_inducement': 0,
      'home_prayer_list': [],
      'home_pop_d3': 0,
      'home_pop_factor': null,
      'visitors_fans': null,
      'visitors_fame': null,
      'visitors_inducement': null,
      'visitors_treasury_for_inducement': 0,
      'visitor_prayer_list': [],
      'visitor_pop_factor': null,
      'visitor_pop_d3': 0,
      'error_msg': null,
      'isInit': false,
      'showCreateWeekModal': false,
      'showMessage': false,
      'weekErrorsList': [],
      'errorsList': [],
      'selectedReferee': null,
      'selectedStadium': null,
      'mrUpdated': false,
      'trUpdated': false,
      'normal_stadium': true,
      'special_stadium': false,
      'stadium_type': null
    }
  },
  watch: {
    current: function (newMr, oldState) {
      if (newMr.is_db_report) {
        this.$router.push({name: 'mrDBStep2', params: { id: newMr.id }})
        return
      }
      if (oldState === null) {
        this.initDatas(newMr)
      }
    },
    trUpdated: function (newVal, oldVal) {
      if (this.mrUpdated === true) {
        this.mrUpdated = false
        this.trUpdated = false
        this.goToNext()
      }
    },
    mrUpdated: function (newVal, oldVal) {
      if (this.trUpdated === true) {
        this.mrUpdated = false
        this.trUpdated = false
        this.goToNext()
      }
    },
    special_stadium: function (newVal, oldVal) {
      if (newVal === true) {
        this.normal_stadium = false
      }
    },
    normal_stadium: function (newVal, oldVal) {
      if (newVal === true) {
        this.special_stadium = false
      }
      this.stadium_type = null
      this.selectedStadium = this.$store.getters.stadiumList.find(stad => { return stad.id === 1 })
    },
    stadiumList: function (newVal, oldVal) {
      if (newVal) {
        this.selectedStadium = this.$store.getters.stadiumList.find(stad => { return stad.id === 1 })
      }
    },
    home_pop_d3: function (newVal, oldVal) {
      if (newVal) {
        this.home_pop_factor = parseFloat(this.detailedHome.pop) + parseFloat(this.home_pop_d3)
      }
    },
    visitor_pop_d3: function (newVal, oldVal) {
      if (newVal) {
        this.visitor_pop_factor = parseFloat(this.detailedVisitor.pop) + parseFloat(this.visitor_pop_d3)
      }
    }

  },
  computed:
  {
    ...mapGetters([
      'currentUser',
      'weekList',
      'matchReportList',
      'teamsForReport',
      'nufflePrayers',
      'stadiumList'
    ]),
    ...mapGetters({
      current: 'detailedMatchReport'
    }),
    weekListForLeague: function () {
      if (this.home) {
        return store.getters.weekListForLeague(this.current.league.id)
      }
      return null
    },
    lastWeek: function () {
      if (this.home) {
        return store.getters.lastWeekListForLeague(this.current.league.id)
      }
      return null
    },
    detailedHome: function () {
      if (!this.home || !this.teamsForReport) {
        return null
      }
      return this.teamsForReport.find(t => { return t.id === this.home.id })
    },
    detailedVisitor: function () {
      if (!this.visitors || !this.teamsForReport) {
        return null
      }
      return this.teamsForReport.find(t => { return t.id === this.visitors.id })
    },
    home: function () {
      return this.current.home_report.team
    },
    visitors: function () {
      return this.current.visitor_report.team
    },
    home_report: function () {
      return this.current.home_report
    },
    visitors_report: function () {
      return this.current.visitor_report
    },
    home_petty_cash: function () {
      if (this.detailedHome.TV >= this.detailedVisitor.TV) {
        return 0
      }
      return this.detailedVisitor.TV - this.detailedHome.TV
    },
    visitor_petty_cash: function () {
      if (this.detailedVisitor.TV >= this.detailedHome.TV) {
        return 0
      }
      return this.detailedHome.TV - this.detailedVisitor.TV
    },
    visitor_final_ve: function () {
      return this.detailedVisitor.TV + this.visitor_petty_cash + this.visitors_treasury_for_inducement / 1000
    },
    home_final_ve: function () {
      return this.detailedHome.TV + this.home_petty_cash + this.home_treasury_for_inducement / 1000
    },
    home_prayer_cpt: function () {
      console.log(this.home_finale_ve)
      console.log(this.visitor_final_ve)
      if (this.home_finale_ve >= this.visitor_final_ve) {
        return 0
      }
      return Math.trunc((this.visitor_finale_ve - this.home_final_ve) / 50)
    },
    visitor_prayer_cpt: function () {
      if (this.visitor_final_ve >= this.home_finale_ve) {
        return 0
      }
      return Math.trunc((this.home_finale_ve - this.visitor_final_ve) / 50)
    }
  },
  methods: {
    getStadiumTypeName (stadiumType) {
      if (stadiumType === 0) {
        return 'Surface de jeu infabituelle'
      }
      if (stadiumType === 1) {
        return 'Brut de décoffrage'
      }
      if (stadiumType === 2) {
        return 'Luxueux'
      }
      if (stadiumType === 3) {
        return 'Public local'
      }
    },
    initDatas () {
      if (!this.weekList ||
           !this.$store.getters.refereeList ||
           !this.$store.getters.stadiumList ||
           !this.current) {
        return
      }
      // init match report datas
      this.match_week = this.weekList.find(w => { return w.id === this.current.week.id }).id
      this.selectedReferee = this.$store.getters.refereeList.find(ref => { return ref.id === this.current.referee.id })
      if (this.current.stadium.id === 1) {
        this.normal_stadium = true
        this.special_stadium = false
      } else {
        this.normal_stadium = false
        this.special_stadium = true
      }
      this.selectedStadium = this.$store.getters.stadiumList.find(stadium => { return stadium.id === this.current.stadium.id })
      this.weather = this.current.weather
      this.match_date = this.current.date

      // init home report datas
      this.home_fans = this.current.home_report.supporters
      this.home_fame = this.current.home_report.fame
      this.home_inducement = this.current.home_report.inducement
      this.home_pop_d3 = this.current.home_report.fan_dice_result
      this.home_pop_factor = this.current.home_report.pop_factor
      this.home_treasury_for_inducement = this.current.home_report.treasury_for_inducement * 1000

      // init visitor report datas
      this.visitors_fans = this.current.visitor_report.supporters
      this.visitors_fame = this.current.visitor_report.fame
      this.visitors_inducement = this.current.visitor_report.inducement
      this.visitors_treasury_for_inducement = this.current.visitor_report.treasury_for_inducement * 1000
      this.visitor_pop_d3 = this.current.visitor_report.fan_dice_result
    },
    checkTeamReport () {
      this.errorsList = []
      if (this.home_pop_d3 === 0) {
        this.errorsList.push('Saisir le D3 de la pop pour ' + this.current.home_report.team.name)
        return false
      } else if (this.visitor_pop_d3 === 0) {
        this.errorsList.push('Saisir le D3 de la pop ' + this.current.visitor_report.team.name)
        return false
      } else if (this.home_treasury_for_inducement !== 0 && (this.home_treasury_for_inducement % 1000) !== 0) {
        this.errorsList.push('la tréso d\'inducement de ' + this.current.home_report.team.name + ' doit être un multiple de 1000')
        return false
      } else if (this.visitors_treasury_for_inducement !== 0 && (this.visitors_treasury_for_inducement % 1000) !== 0) {
        this.errorsList.push('la tréso d\'inducement de ' + this.current.home_report.team.name + ' doit être un multiple de 1000')
        return false
      } else {
        return true
      }
    },
    checkMatchReport () {
      this.errorsList = []
      if (this.match_week === null) {
        this.errorsList.push('Il faut choisir une journée avant de valider')
        return false
      } else if (this.match_date === null) {
        this.errorsList.push('Il faut choisir une date de rencontre avant de valider')
        return false
      } else if (this.weather === null) {
        this.errorsList.push('Il faut choisir une météo avant de valider')
        return false
      } else if (this.selectedReferee === null) {
        this.errorsList.push('Il faut choisir un arbitre avant de valider')
        return false
      } else if (this.selectedStadium === null) {
        this.errorsList.push('Il faut choisir un stade avant de valider')
        return false
      } else {
        return true
      }
    },
    weekCreated () {
      store.dispatch('getWeekList')
      this.showCreateWeekModal = false
      this.showMessage = true
    },
    checkAlreadyPlayedMatch () {
      if (this.match_week) {
        // on cherche les rapport home sur la semaine choisie
        let homeMatches = store.getters.matchReportListForTeam(this.home.id)
        let visitorMatches = store.getters.matchReportListForTeam(this.visitors.id)
        if (homeMatches.length === 0 && visitorMatches.length === 0) {
          return
        }
        let foundHomeReport = homeMatches.find(report => {
          return report.week === this.match_week
        })

        if (foundHomeReport) {
          this.weekErrorsList.push('L\'équipe ' + this.home.name + ' a déjà un rapport de match sur la journée ' + this.match_week.title + ', les équipes ne peuvent pas jouer deux fois sur une même journée.')
        }

        let foundVisitorReport = visitorMatches.find(report => {
          return report.week === this.match_week
        })

        if (foundVisitorReport) {
          this.weekErrorsList.push('L\'équipe ' + this.visitors.name + ' a déjà un rapport de match sur la journée ' + this.match_week.title + ', les équipes ne peuvent pas jouer deux fois sur une même journée.')
        }
        console.log('already played match checked')
      }
    },
    previous () {
      this.$router.push({name: 'mrStep1', params: { id: this.id }})
    },
    goToNext () {
      this.$router.push({
        name: 'mrStep3',
        params: {
          id: this.current.home_report.id,
          teamid: this.current.home_report.team.id,
          matchId: this.current.id
        }
      })
      this.$store.dispatch('invalidateDetailedMatchReport')
    },
    validate () {
      if (this.checkMatchReport() === false) {
        return
      }
      if (this.checkTeamReport() === false) {
        return
      }

      // update match report datas
      let mr = {}
      mr.id = this.current.id
      mr.weather = this.weather
      mr.referee = this.selectedReferee.id
      mr.stadium = this.selectedStadium.id
      mr.date = this.match_date
      mr.week = this.match_week
      matchReport.api.updateMatchReport(mr).then(
        response => {
          this.mrUpdated = true
        },
        error => {
          this.errorsList.push(error.body.detail)
        }
      )

      // bulk update team report datas
      let trArray = []
      let homeReport = {}
      homeReport.id = this.current.home_report.id
      homeReport.fame = parseFloat(this.detailedHome.pop) + parseFloat(this.home_pop_d3)
      homeReport.inducement = this.home_inducement
      homeReport.treasury_for_inducement = this.home_treasury_for_inducement / 1000
      homeReport.fan_dice_result = this.home_pop_d3
      homeReport.petty_cash = this.home_petty_cash
      homeReport.pop_factor = this.home_pop_factor
      trArray.push(homeReport)

      let visitorReport = {}
      visitorReport.id = this.current.visitor_report.id
      visitorReport.supporters = this.visitors_fans
      visitorReport.fame = this.visitors_fame
      visitorReport.inducement = this.visitors_inducement
      visitorReport.treasury_for_inducement = this.visitors_treasury_for_inducement / 1000
      visitorReport.fan_dice_result = this.visitor_pop_d3
      visitorReport.petty_cash = this.visitor_petty_cash
      visitorReport.pop_factor = this.visitor_pop_factor
      trArray.push(visitorReport)

      teamReport.api.bulkUpdateTeamReport(trArray).then(
        response => {
          this.trUpdated = true
        },
        error => {
          this.errorsList.push(error.body.detail)
        }
      )
    }
  },
  mounted () {
    this.$store.dispatch('invalidateDetailedMatchReport')
    this.$store.dispatch('getDetailedMatchReport', this.id.toString())
    this.$store.dispatch('getTeamInfosForMatchReport', this.id.toString())
    this.$store.dispatch('getNufflePrayersList')
  },
  created () {
    this.$store.dispatch('activateFullSizePage')
    store.dispatch('hideLeaguePanel')
    store.dispatch('getWeekList')
    this.$store.dispatch('getRefereeList')
    this.$store.dispatch('getStadiumList')
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.big-title {
    font-size: 1.6rem;
}
.match-team-name {
    font-size: 1.3rem;
}

.day-select {
    padding-left: 0;
}
.day-button {
    padding: 0.8rem;
}

.error {
  color: #a94442;
}

.title {
  background-color: #ecf3f5;
  border-top: solid 1px #dadada;
  border-bottom: solid 1px #dadada;
  font-weight: 500;
  font-size: 1.2rem;
  text-align: left;
  padding-left: 1rem;
  padding-top: 0.3rem;
  padding-bottom: 0.3rem;
  margin-bottom: 1rem;
}

.section {
  padding-bottom: 1rem;
}

.fans {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  margin-bottom: 0.7rem;
}

.pb-1 {
  padding-bottom: 0.4rem;
}

.cb_label {
  color: #2c3f4c;
  font-size: 1rem;
}

.mt-2{
  margin-top: 0.3rem;
}

.field {
  margin-left:1rem;
}

.inducements {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 3fr;
  margin-bottom: 0.7rem;
}

.nuffle {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 4fr;
  margin-bottom: 0.7rem;
}


.infos_gen {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  margin-bottom: 0.7rem;
}
.pb-4 {
  padding-bottom: 1.4rem;
}
</style>



// WEBPACK FOOTER //
// mr-step-2.vue?062d85e6